// The hero's scene, under the copy: the 3.4 exploration's (this Mac asleep, the cloud machine working, the phone
// asking), as it was. The Mac mini that beams to the laptop and the phone replaces it next.
import { useEffect, useRef } from 'react';
import { mountHero } from './hero';
import './hero.css';

export function HeroArt() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => (ref.current ? mountHero(ref.current) : undefined), []);
  return (
    <div className="hero-art">
      <div className="h13" ref={ref} />
    </div>
  );
}
